// import { React, useState } from "react";
import JPGramma from './JPGramma.js'
import JPWord from "./JPWord.js";

const states = require("../../../utils/states.js")



export default (props) => {
  if (!props.needRender) return;
  if (states.curBookInfo().bGrammaBook) {
    return <JPGramma filterFunc={props.filterFunc} />
  } else {
    return <JPWord filterFunc={props.filterFunc} />
  }
}